import * as React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { Button, SearchInput } from '../../..'
import { StoresSearchModes } from '../../../../actions/stores'
import { withSize } from '../../../utils'
import { ClearFilters, TimesIcon, Inline } from './EstateList.styles'
import EstateBanner from './EstateBanner'

const FilterButton = styled(Button)`
    margin-bottom: 5px;
    font-size: 12px;
    color: white;
`

interface EstateListTitleProps {
    children?: JSX.Element
    clearFilters?: () => void
    isFilterActive: boolean
    isMobile: boolean
    onChangeSearch?: (e: React.FormEvent<HTMLInputElement>) => void
    onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void
    openCloseFilters?: (v: string) => void
    totalData: number
    totalFilteredData: number
    valueSearch: string
}

function EstateListTitle(props: EstateListTitleProps) {
    const {
        children,
        clearFilters,
        isFilterActive = false,
        isMobile = false,
        onChangeSearch,
        onKeyPress = () => null,
        openCloseFilters,
        totalData = 0,
        totalFilteredData = 0,
        valueSearch = '',
    } = props

    const { t } = useTranslation()
    const timeoutRef = React.useRef<NodeJS.Timeout>()

    React.useEffect(
        () => (): void => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        },
        []
    )

    const onClearFilters = (): void => {
        if (typeof clearFilters !== 'function') {
            return
        }

        clearFilters()
    }

    return (
        <>
            <EstateBanner />
            <div className="store-taskbar">
                {!isMobile && (
                    <div className="store-taskbar-left">
                        {totalFilteredData !== null && totalData !== null && (
                            <div>
                                {t('filter-counter', {
                                    filtered: totalFilteredData,
                                    total: totalData,
                                })}
                            </div>
                        )}
                    </div>
                )}
                <div className="store-taskbar-right">
                    {children}
                    <Inline>
                        <SearchInput
                            onChange={onChangeSearch}
                            onKeyPress={onKeyPress}
                            value={valueSearch}
                            placeholder={t('store-code-name-device-id')}
                            width="230px"
                        />
                        <ClearFilters onClick={onClearFilters} show={isFilterActive} >
                            <TimesIcon icon="times" />
                        </ClearFilters>
                    </Inline>
                    <Inline style={{ marginLeft: '5px' }}>
                        <FilterButton
                            icon="sliders-h"
                            theme="light" 
                            onClick={() => {
                                if (openCloseFilters) {
                                    openCloseFilters(StoresSearchModes.searchByStore.value)
                                }
                            }}
                        />
                    </Inline>
                </div>
            </div>
        </>
    )
}

export default withSize(EstateListTitle)
